/** @jsx jsx */
import type { SerializedStyles } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  slide: css`
    flex: 0 0 auto;
    min-width: 0;
    position: relative;
  `,
};

type Props = {
  className?: string;
  'aria-label'?: string;
  /** Additional emotion styles merged with the base slide styles. Use to override flex-basis for responsive layouts. */
  slideCss?: SerializedStyles | SerializedStyles[];
};

const CarouselSlide = ({ children, className, 'aria-label': ariaLabel, slideCss }: React.PropsWithChildren<Props>) => {
  const mergedCss = slideCss ? [styles.slide, ...(Array.isArray(slideCss) ? slideCss : [slideCss])] : styles.slide;
  return (
    <div css={mergedCss} className={className} role="group" aria-roledescription="slide" aria-label={ariaLabel}>
      {children}
    </div>
  );
};

export default CarouselSlide;
